'use es6';

import PropTypes from 'prop-types';
import { useState } from 'react';
import styled, { css, useTheme } from 'styled-components';
import VizExLoadingButton from 'visitor-ui-component-library/button/VizExLoadingButton';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CIRRUS, EERIE, GYPSUM } from 'HubStyleTokens/colors';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { ChatWidgetLocaleContextConsumer } from './ChatWidgetLocaleContext';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import VizExCloseButton from 'visitor-ui-component-library/button/VizExCloseButton';
import { createThemeV2 } from 'visitor-ui-component-library/theme/createThemeV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "ConsentPrompt__Container",
  componentId: "ci2uzk-0"
})(["border-top:", ";display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;padding:12px 24px;position:relative;background:", ";"], props => props.isOutsideChat ? '0' : `2px solid ${CIRRUS}`, ({
  theme: {
    config
  }
}) => (config === null || config === void 0 ? void 0 : config.isUngatedForUpdatedUI) && GYPSUM);
const SmallNoParagraphPadding = styled(VizExSmall).withConfig({
  displayName: "ConsentPrompt__SmallNoParagraphPadding",
  componentId: "ci2uzk-1"
})(["display:block;line-height:", ";word-break:break-word;word-wrap:break-word;-ms-word-break:break-all;p{margin-bottom:0;}"], ({
  theme: {
    config
  }
}) => (config === null || config === void 0 ? void 0 : config.isUngatedForUpdatedUI) && '24px');
const FullWidthButton = styled(VizExButton).withConfig({
  displayName: "ConsentPrompt__FullWidthButton",
  componentId: "ci2uzk-2"
})(["flex:0 1 100%;", ""], ({
  theme
}) => {
  var _theme$config;
  return ((_theme$config = theme.config) === null || _theme$config === void 0 ? void 0 : _theme$config.isUngatedForUpdatedUI) && css(["margin:0 auto;width:fit-content;flex:0 0 auto;border-radius:999px;"]);
});
const FlexWrapper = styled.div.withConfig({
  displayName: "ConsentPrompt__FlexWrapper",
  componentId: "ci2uzk-3"
})(["display:flex;flex-direction:row;width:100%;margin:12px 0 8px 0;"]);
const ConsentPrompt = ({
  message,
  onClick,
  onClose,
  showButton,
  isPortal53,
  isOutsideChat = false
}) => {
  var _theme$config2;
  const theme = useTheme();
  const [submitting, setSubmitting] = useState(false);
  const onClickWrapper = () => {
    onClick();
    setSubmitting(true);
  };
  return /*#__PURE__*/_jsxs(Container, {
    "data-test-id": "gdpr-consent-prompt",
    dir: "auto",
    isOutsideChat: isOutsideChat,
    className: ((_theme$config2 = theme.config) === null || _theme$config2 === void 0 ? void 0 : _theme$config2.isUngatedForUpdatedUI) && !showButton && 'm-bottom-4',
    children: [!showButton && isPortal53 && /*#__PURE__*/_jsx(VizExCloseButton, {
      size: 'sm',
      onClick: onClose,
      theme: isOutsideChat ? createThemeV2({
        colors: {
          text: EERIE
        }
      }) : createThemeV2()
    }), /*#__PURE__*/_jsx(SmallNoParagraphPadding, {
      use: "help",
      "data-test-id": "gdpr-consent-text",
      dangerouslySetInnerHTML: {
        __html: formatHtml(message)
      },
      isOutsideChat: isOutsideChat
    }), showButton && /*#__PURE__*/_jsx(FlexWrapper, {
      children: /*#__PURE__*/_jsx(VizExLoadingButton, {
        currentState: submitting ? 'submitting' : 'ready',
        Button: FullWidthButton,
        "data-test-id": "gdpr-consent-agree-button",
        onClick: onClickWrapper,
        children: /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
          children: locale => /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-experience-components.buttons.agree",
            options: {
              locale
            }
          })
        })
      })
    })]
  });
};
ConsentPrompt.propTypes = {
  isOutsideChat: PropTypes.bool,
  isPortal53: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showButton: PropTypes.bool.isRequired
};
ConsentPrompt.displayName = 'ConsentPrompt';
export default ConsentPrompt;